import React from 'react';
import '../../styles/WhatsAppLoading.scss';

/**
 * Loading component shown while validating WhatsApp permissions
 */
const WhatsAppLoading = () => {
  return (
    <div className="whatsapp-loading-container">
      <div className="whatsapp-loading-content">
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
        <h3>Validating WhatsApp Access</h3>
        <p>Please wait while we verify your permissions...</p>
      </div>
    </div>
  );
};

export default WhatsAppLoading;